module.exports = __webpack_public_path__ + "img/pd-img-head6.ddea2af6.png";